<!-- SIDENAV HEADER -->
<div fxLayout="column" fxLayoutAlign="space-between start" class="header p-24 pb-4" ngClass="mat-accent-bg"
    ngClass.gt-md="white-fg">
    <div class="logo" fxFlex fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon s-32">check_box</mat-icon>
        <span class="logo-text">{{title}}</span>
    </div>
</div>
<!-- / SIDENAV HEADER -->

<!-- SIDENAV CONTENT -->
<div class="content" fusePerfectScrollbar *fuseIfOnDom>

    <div class="p-24" *ngIf="ShowAddButton">
        <button mat-raised-button fxFlex class="mat-accent add-task-button" (click)="newTask()" aria-label="ADD TASK"
            [disabled]="userReadOnly">
            ADD TASK
        </button>
    </div>

    <div class="nav">
        <div class="nav-subheader">SORT ORDER</div>
        <div class="nav-item" *ngFor="let order of this.taskService.getSortOrders()">
            <a class="nav-link" matRipple (click)="btnApplySortOrder(order)"
                [attr.aria-label]="'Sort by ' + order.title">
                <mat-icon *ngIf="order.selected && order.order!==1">arrow_drop_down</mat-icon>
                <mat-icon *ngIf="order.selected && order.order===1">arrow_drop_up</mat-icon>
                <mat-icon *ngIf="!order.selected"></mat-icon>
                <span>&nbsp;{{order.title}}</span>
            </a>
        </div>
    </div>

    <div class="nav">
        <div class="nav-subheader">FILTERS</div>
        <div class="nav-item" *ngFor="let filter of filters">
            <a class="nav-link" matRipple (click)="btnApplyFilter(filter)" [attr.aria-label]="filter.title + ' Tasks'">
                <mat-icon class="nav-link-icon" *ngIf="filter.icon">{{filter.icon}}</mat-icon>
                <span>{{filter.title}}&nbsp;</span>
                <mat-icon class="nav-link-icon" *ngIf="filter.selected">done</mat-icon>
            </a>
        </div>
    </div>
</div>
<!-- / SIDENAV CONTENT -->